import 'bootstrap';
import 'select2';

window.bootstrap = require('bootstrap');

$(document).ready(function () {
    let $body = $("body");

    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    let report = {
        lines: () => {
            let $stopsdirs = $(".cbc-report__stops-dir");

            $stopsdirs.each(function () {
                let $stopsdir = $(this);

                let index = 0;
                let $stops = $stopsdir.find(".cbc-report__stop");

                let isStopActive = ($stop) => {
                    if ($stop.is("[data-impacted=1]") || $stop.is("[data-first=1]") || $stop.is("[data-last=1]")) {
                        return true;
                    }
                };

                $stops.each(function () {
                    let $stop = $(this);

                    let $prevStop = $stops.eq(index - 1);
                    let $nextStop = $stops.eq(index + 1);
                    let $overNextStop = $stops.eq(index + 2);

                    if (isStopActive($stop)) {
                        // currently active
                    } else if (
                        isStopActive($nextStop) || isStopActive($prevStop)
                    ) {
                        // inactive but next to active
                        if (!isStopActive($nextStop) && !$stop.is("[data-last=1]") && !$overNextStop.is("[data-last=1]")) {
                            $stop.after("<div class='cbc-report__stop-spacer' aria-hidden='true'>&nbsp;</div>")
                        }
                    } else {
                        $stop.hide();
                    }

                    index++;
                })
            });
        },
        accordion: () => {
            let duration = 400;

            // Scroll once a report has finished opening (not on close).
            // Native listener: without window.jQuery Bootstrap doesn't trigger jQuery events.
            document.addEventListener("shown.bs.collapse", function (event) {
                // Ignore nested collapses like "Betroffene Zugnummern"
                if (!event.target.matches(".cbc-report__accordion > .accordion-collapse")) {
                    return;
                }

                let $targetElement = $(event.target).find(".cbc-report");
                let offset = $targetElement.offset().top - ($(window).height() / 3);

                // Bootstrap's "scroll-behavior: smooth" would smooth every animation step again
                let $html = $("html");
                $html.css("scroll-behavior", "auto");

                $("html, body").stop().animate({scrollTop: offset}, duration, function () {
                    $html.css("scroll-behavior", "");
                });
            });
        },
        filters: () => {
            let $filters = $("select.cbc-filter");
            let focuskey = "cbcFilterFocus";
            let usingkeyboard = false;
            let changedbykeyboard = false;

            let submit = ($filter) => {
                // Put the focus back on this filter after the reload (storage can be blocked, e.g. in iframes)
                try {
                    sessionStorage.setItem(focuskey, $filter.attr("id"));
                } catch (e) {
                }

                $filter.closest("form").submit();
            };

            try {
                let focusid = sessionStorage.getItem(focuskey);
                sessionStorage.removeItem(focuskey);
                if (focusid) {
                    $("#" + $.escapeSelector(focusid)).trigger("focus");
                }
            } catch (e) {
            }

            // Mouse: submit right away. Keyboard: arrow keys already change the value,
            // so only submit on Enter or when leaving the field, otherwise every step would reload the page.
            $filters.on("mousedown", function () {
                usingkeyboard = false;
            });

            $filters.on("keydown", function (event) {
                usingkeyboard = true;

                if (event.key === "Enter" && changedbykeyboard) {
                    event.preventDefault();
                    submit($(this));
                }
            });

            $filters.on("change", function () {
                if (usingkeyboard) {
                    changedbykeyboard = true;
                    return;
                }

                submit($(this));
            });

            $filters.on("blur", function () {
                if (changedbykeyboard) {
                    submit($(this));
                }
            });
        }
    }

    if ($(".cbc-filter").length) {
        report.filters();
    }

    if ($(".cbc-report__stops-dir").length) {
        report.lines();
    }

    // Hint "Bitte Linie auswählen" is only needed until a line was selected (native listener, see accordion)
    document.addEventListener("shown.bs.tab", function (event) {
        if (!event.target.matches(".cbc-report__line")) {
            return;
        }

        $(event.target).closest(".cbc-report__stops-box").find(".cbc-report__stops-hint").remove();
    });

    if ($("button.cbc-report-title").length) {
        report.accordion();
    }
});